import * as React from 'react';
import { FieldProps, Text, FormValue } from 'informed';
import { Button } from 'reactstrap';
import { validateText } from '../form.utils';
import { InputModel } from './input.model';
import { Icon } from 'src/app';

import '../../../../assets/sass/theme/theme.scss';

// TODO Replace any
export interface PasswordFieldProps {
  field: InputModel;
  fieldProps: FieldProps<any, any> & React.InputHTMLAttributes<HTMLInputElement>;
}

export interface PasswordFieldState {
  type: 'password' | 'text';
}


export class PasswordField extends React.Component<PasswordFieldProps, PasswordFieldState> {
  constructor(props: PasswordFieldProps) {
    super(props);

    this.state = {
      type: 'password',
    };

    this.handleClick = this.handleClick.bind(this);
  }
  public render() {
    const { 
      type,
      ...rest
    } = this.props.fieldProps;
    return (
      <>
        <Text 
          type={this.state.type}
          validate={(value: FormValue, values: any) => {
            return validateText(value, this.props.field, values);
          }}
          {...rest} 
        />
        <Button 
          onClick={this.handleClick}
          className="show-hide-pw"
        >
          {this.state.type === 'password' && (
            <Icon name="no-view" size={'small'} />
          )}
          {this.state.type === 'text' && (
            <Icon name="view" size={'small'} />
          )}
        </Button>
      </>
    );
  }

  private handleClick () {
    this.setState({
      type: this.state.type === 'password' ? 'text' : 'password',
    });
  }
}

export default PasswordField;